import Component from '@glimmer/component';
import timezones from 'scaleflow/utils/timezone';
export default class TimeZonePickerComponent extends Component {
  get ComponentName() {
    return this.args.tippy ? 'Tippy' : 'empty-component';
  }

  get timezones() {
    return timezones;
  }
}
